import { render, staticRenderFns } from "./AutomationUpdated.vue?vue&type=template&id=52fdce54&scoped=true"
import script from "./AutomationUpdated.vue?vue&type=script&lang=js"
export * from "./AutomationUpdated.vue?vue&type=script&lang=js"
import style0 from "./AutomationUpdated.vue?vue&type=style&index=0&id=52fdce54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdce54",
  null
  
)

export default component.exports